import DOMManipulator from "./DOMManipulator";
import { mergeObjects } from "./helpers";

const ICoreAPI = {
    lenis: null,
    animator: null,
    copy: function(str, element) {
        var _temp = jQuery("<input>");
        jQuery("body").append(_temp);
        _temp.val(str).select();
        document.execCommand("copy");
        _temp.remove();

        var texthtml = element.innerHTML;
        element.innerHTML = `<span class="copy-post-button--icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z"/></svg>
        </span>
        <span class="copy-post-button--text">Copied!</span>`;

        setTimeout(function() {
            element.innerHTML = texthtml;
        }, 3000);
    },
    dom: DOMManipulator,
    toast: {
        /**
        *
        * @param {String} message The message to display on the toast
        * @param {String} status Status. e.g. `success`, `error`, `info`, `warning`
        * @param {String} title Enter the title for the toast. Empty by default
        * @param {String} display `topRight`, `bottomCenter` etc
        * @param {Integer} timeout timeout. default is 3000
        * @param {Object} callbacks  object of callbacks
        */
        show: function( message, status = 'success', title = '', display = 'topCenter', timeout = 3000, callbacks = {} ) {
            let options  = {
                title: title,
                message: message,
                timeout: timeout,
                position: display,
                progressBarColor: 'rgb(50,110,207,1)',
                zindex: 999999,
                layout: 2,
                drag: false,
                transitionIn: "fadeIn",
                transitionOut: "fadeOut",
                ransitionInMobile: 'fadeIn',
                transitionOutMobile: 'fadeOut',
            };

            if ( Object.keys(callbacks).length > 0 ) {

                if (callbacks.onOpening && typeof callbacks.onOpening === 'function') {
                    options.onOpening = callbacks.onOpening;
                }

                if (callbacks.onOpened && typeof callbacks.onOpened === 'function') {
                    options.onOpened = callbacks.onOpened;
                }

                if (callbacks.onClosing && typeof callbacks.onClosing === 'function') {
                    options.onClosing = callbacks.onClosing;
                }

                if (callbacks.onClosed && typeof callbacks.onClosed === 'function') {
                    options.onClosed = callbacks.onClosed;
                }
            }

            switch (status) {
                case 'error':
                    iziToast.error(mergeObjects(options, {
                        iconUrl: rPayAppJs.toast_baseUrl + '/error.svg'
                    }));
                break;
                case 'info':
                    iziToast.info(mergeObjects(options, {
                        iconUrl: rPayAppJs.toast_baseUrl + '/info.svg'
                    }));
                break;
                case 'warning':
                    iziToast.warning(mergeObjects(options, {
                        iconUrl: rPayAppJs.toast_baseUrl + '/warning.svg'
                    }));
                break;
                default:
                    iziToast.success(mergeObjects(options, {
                        iconUrl: rPayAppJs.toast_baseUrl + '/success.svg'
                    }));
                break;
            }
        }
    },
    once: function(el, event, fn, opts) {
        let onceFn = function (e) {
            el.removeEventListener(event, onceFn);
            fn.apply(this, arguments);
        };
        el.addEventListener(event, onceFn, opts);
        return onceFn;
    }
}

export default ICoreAPI;